import {
  Box,
  Typography,
  IconButton,
  SystemIcon,
} from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { Icon, IconName } from '@/shared/Components';

interface GrassInfoTipProps {
  icon: IconName;
  title: string;
  description: string;
}

export const GrassInfoModalTitle = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box className="flex flex-col gap-1.5 px-5 desktop:px-8">
      <Box className="flex items-center justify-between">
        <Typography
          variant="subTitle1"
          className="font-bold text-w-bluegray-900"
        >
          풍성한 성장 잔디를 만드는 방법
        </Typography>
        <IconButton onClick={onClose} size="sm" outline={false}>
          <SystemIcon name="large_delete" />
        </IconButton>
      </Box>
      <Typography variant="body1" className="text-w-gray-600">
        하루 동안의 활동 점수가 잔디로 기록됩니다.
      </Typography>
    </Box>
  );
};

export const GrassInfoModalBody = () => {
  const grassTips: GrassInfoTipProps[] = [
    {
      icon: 'eye',
      title: '콘텐츠 조회',
      description: '열심히 읽을수록 점수가 올라가요.',
    },
    {
      icon: 'heart',
      title: '좋아요',
      description: '콘텐츠에 좋아요를 눌러보세요.',
    },
    {
      icon: 'scrap',
      title: '스크랩',
      description: '도움 된 콘텐츠를 스크랩해요.',
    },
    {
      icon: 'collection',
      title: '컬렉션',
      description: '실무 꿀팁, 내 컬렉션에 담아요.',
    },
    {
      icon: 'highlight',
      title: '형광펜과 메모',
      description: '기억하고 싶은 문장을 형광펜 해요.',
    },
    {
      icon: 'arlam',
      title: '작가 알림',
      description: '관심 작가의 발행 소식을 받아요.',
    },
  ];

  return (
    <Box className="flex flex-col gap-4 overflow-auto px-5 scrollbar-list desktop:px-8">
      {grassTips.map((tip, index) => (
        <GrassInfoTipCard key={index} {...tip} />
      ))}
    </Box>
  );
};

const GrassInfoTipCard = ({ icon, title, description }: GrassInfoTipProps) => {
  return (
    <Box
      className={twJoin(
        'flex items-center gap-5 rounded-2xl bg-w-bluegray-10 p-5',
        'desktop:gap-6 desktop:px-6 desktop:py-5'
      )}
    >
      <Icon name={icon} />
      <Box className="flex flex-col gap-0.5">
        <Typography variant="body1" className="font-medium text-w-gray-900">
          {title}
        </Typography>
        <Typography variant="body1" className="text-w-gray-600">
          {description}
        </Typography>
      </Box>
    </Box>
  );
};
